import algoliasearch from "algoliasearch/lite"
import { useMemo } from "react"
import { useConfigContext } from "~/providers/ConfigProvider"

export interface AlgoliaHitData {
  queryId: string
  index: string
  position: number
}

export const hitDataToExternalData = (
  algoliaHitData: AlgoliaHitData,
  productId: string
) => ({
  algolia_query_id: algoliaHitData.queryId,
  algolia_index: algoliaHitData.index,
  algolia_position: algoliaHitData.position,
  algolia_event_type: "click",
  algolia_object_id: productId
})

export const useAlgoliaClient = () => {
  const config = useConfigContext()

  const client = useMemo(
    () => algoliasearch(config.algoliaAppId, config.algoliaApiKey),
    [config]
  )

  return client
}

export type AlgoliaResults = {
  [key: string]: AlgoliaResult
}

export type AlgoliaResult = {
  hits: any[]
  totalPages: number
  totalHits: number
  queryId?: string
  page?: number
}
